import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Service } from 'src/app/shared/models/service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-edit-service',
  templateUrl: './edit-service.component.html',
  styleUrl: './edit-service.component.scss'
})


export class EditServiceComponent {

  item: Service = new Service()
  directions: any;
  items: any;

  constructor(
    private modalService: NgbModal,
    private paramService: ParameterService,
    private localstorage: LocalStorageService,
    private messageService: MessageService,
    private loader: NgxUiLoaderService,
    private fetchService: FecthDataService,
    private paramservice: ParameterService,


  ) { }


  ngOnInit() {

    this.item = this.localstorage.getService();
    //console.log("this.item", this.item);
    this.items = this.localstorage.getService();

    this.fetchDataDirection();
  }

  close() {

    this.modalService.dismissAll();
  }


  Edit() {
  
    this.loader.start();
    const item = this.localstorage.getService();
    this.item.direction_id = this.item.direction_id.id;
        this.loader.start();

    this.paramService.editService(item.id, this.item).subscribe(
      (response: any) => {
        this.loader.stop();
        
        this.messageService.add({ severity: 'success', summary: '', detail: response.message });

        //console.log("la reponse du webservice", response);
        this.fetchService.notifySeriviceCreated();
        this.modalService.dismissAll();
      },
      (error: any) => {
        //console.log("une erreur est survenu", error);
        this.loader.stop();
        this.messageService.add({ severity: 'success', summary: '', detail: error.error.message });

      }
    )
  }


  fetchDataDirection() {
    this.paramservice.fetchDataDirection().subscribe(
      (response: any) => {
        this.directions = response.data;
        this.item.direction_id = this.directions.find((item: any) => item.id === this.items?.direction_id);
        //console.log(" this.item.direction_id ", this.item.direction_id);
      },
      (error) => {
        ////console.log("une erreur est survenu",error);
      }

    );
  }

}